﻿window.regioReport = function () {
    var dateTimeErrorMessageLabel = "";

    /*
    * Show / Hide Period Selector
    **/
    function setVisibilityPeriodSelector() {
        var timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

        if (timeinterval_value == timeIntervalEnum.AskedPeriod) {
            $("#periodSelector").show();
        } else {
            $("#periodSelector").hide();
        }
    }

    return {
        /**
        * Initialize
        */
        initialize: function (dateTimeErrorMessage) {
            dateTimeErrorMessageLabel = dateTimeErrorMessage;

            main.setHideDiv("errorMessage", false);
            $("#RegioReportExportRawButtonLoader").hide();
            $("#RegioReportExportButtonLoader").hide();
            $("#RegioReportSearchButtonLoader").hide();            

            setVisibilityPeriodSelector();
        },

        /**
        * Initialize Search
        */
        initializeSearch: function () {
            $(".groupItem").hide();
        },

        /**
        * Click groupItem 
        */
        groupItemClick: function (guid) {

            var selection;

            if ($('#' + guid).is(':hidden')) {
                $('#' + guid).slideDown("slow");
                selection = $("#" + guid).parent().find('.k-i-caret-double-alt-down');

                $(selection).removeClass("k-i-caret-double-alt-down");
                $(selection).addClass("k-i-caret-double-alt-up");
            }
            else
            {
                $('#' + guid).slideUp("slow");
                selection = $("#" + guid).parent().find('.k-i-caret-double-alt-up');

                $(selection).removeClass("k-i-caret-double-alt-up");
                $(selection).addClass("k-i-caret-double-alt-down");
            }

        },

        /**
        * Action export (will download excel document according to the selected period)
        * @param { any } DOMelement
        */
        exportAction: function (DOMelement) {
            // Stop the browser from following
            DOMelement.preventDefault();

            main.setHideDiv("errorMessage", false);

            // Show the waiting indicator
            $("#RegioReportExportButtonLoader").show();

            // get preference / options selected
            var selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());

            // Get selection period
            var from = timeinterval.GetBeginPeriodSelection(selectedInterval, "From");
            if (from != null) {
                from = from.toUTCString();
            }

            var to = timeinterval.GetEndPeriodSelection(selectedInterval, "To");
            if (to != null) {
                to = to.toUTCString();
            }

            if (from != null && to != null) {
                // Download File
                $.fileDownload(appsettings.getLocalUrl("RegioReport/Export?from=" + from + "&to=" + to))
                    .done(function () { $("#RegioReportExportButtonLoader").hide(); })
                    .fail(function () { $("#RegioReportExportButtonLoader").hide(); });
            }
            else {
                // Hide Indicator
                $("#RegioReportExportButtonLoader").hide();

                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },

        /**
        * Action export (will download excel document according to the selected period)
        * @param { any } DOMelement
        */
        exportRawAction: function (DOMelement) {
            // Stop the browser from following
            DOMelement.preventDefault();

            main.setHideDiv("errorMessage", false);

            // Show the waiting indicator
            $("#RegioReportExportRawButtonLoader").show();

            // get preference / options selected
            var selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());

            // Get selection period
            var from = timeinterval.GetBeginPeriodSelection(selectedInterval, "From");
            if (from != null) {
                from = from.toUTCString();
            }

            var to = timeinterval.GetEndPeriodSelection(selectedInterval, "To");
            if (to != null) {
                to = to.toUTCString();
            }

            if (from != null && to != null) {
                // Download File
                $.fileDownload(appsettings.getLocalUrl("RegioReport/ExportRaw?from=" + from + "&to=" + to))
                    .done(function () { $("#RegioReportExportRawButtonLoader").hide(); })
                    .fail(function () { $("#RegioReportExportRawButtonLoader").hide(); });
            }
            else {
                // Hide Indicator
                $("#RegioReportExportRawButtonLoader").hide();

                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },


        /**
        * Action search (will display certain bar charts according to the selected period)
        * @param { any } DOMelement
        */
        searchAction: function (DOMelement) {
            // Indicator
            $("#RegioReportSearchButtonLoader").show();

            main.setHideDiv("errorMessage", false);

            // get preference / options selected
            var selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());
            var selectedPeriod = parseInt($("#PeriodPartSelection").data("kendoDropDownList").value());

            // Get selection period
            var From = timeinterval.GetBeginPeriodSelection(selectedInterval, "From");
            if (From != null) {
                From = moment(From.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
            }

            var To = timeinterval.GetEndPeriodSelection(selectedInterval, "To");
            if (To != null) {
                To = moment(To.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
            }

            if (From != null && To != null) {
                // Do request
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("RegioReport/Search"),
                    data: {
                        From: From,
                        To: To,
                        WorkingDay: selectedPeriod == PeriodPartSelectionEnum.FullPeriod ? null : selectedPeriod
                    },
                    success: function (responseData) {
                        // Get response
                        $("#searchResult").html(responseData);

                        // Hide Indicator
                        $("#RegioReportSearchButtonLoader").hide();
                    }
                });
            }
            else {
                // Hide Indicator
                $("#RegioReportSearchButtonLoader").hide();

                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },

        /**
        * start / from 
        * @param { any } DOMelement
        */
        fromChange: function () {
            var start = $("#From").data("kendoDateTimePicker");
            var end = $("#To").data("kendoDateTimePicker");
            var startDate = start.value();
            var endDate = end.value();

            if (startDate) {
                startDate = new Date(startDate);
                startDate.setDate(startDate.getDate());
                end.min(startDate);
            } else if (endDate) {
                start.max(new Date(endDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        },

        /**
        * end / to
        * 
        * @param { any } DOMelement
        */
        toChange: function () {
            var start = $("#From").data("kendoDateTimePicker");
            var end = $("#To").data("kendoDateTimePicker");
            var endDate = end.value();
            var startDate = start.value();

            if (endDate) {
                endDate = new Date(endDate);
                endDate.setDate(endDate.getDate());
                start.max(endDate);
            } else if (startDate) {
                end.min(new Date(startDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        },

        onChangeTimeInterval: function () {
            setVisibilityPeriodSelector();
        },
    }
}();